import React, { useEffect, useState } from "react";
import './App.css';
import ALlNews from './Components/ALlNews';
import Navbar from './Components/navbar';

function App() {
  const api="pub_74e35ac39f2e458a8b423fb3dce55230";
  // const api="pub_09d7fd396c3241aaadc2b91c7b9509d2";
  const [articles, setArticles] = useState([]);
  const [country, setCountry] = useState("");
  const [category, setCategory] = useState("");
  const [search, setSearch] = useState("");
  const [searchTemp, setSearchTemp] = useState("");
  const [mode,setMode]=useState("light");
  const [spinner,setSpinner]=useState(false);
  const [page,setPage]=useState("");
  const [total_art, setTotal_art] = useState(0)
  const [fetchnext_y, setFetchnext_y] = useState(1)
 const [scrollTop, setScrollTop] = useState(0)
 const [scrollHeight, setScrollHeight] = useState(0)
  const [innerHeight, setInnerHeight] = useState(-100)
  useEffect(() => {
    const fetchData = async () =>{
      
      let url = `https://newsdata.io/api/1/latest?apikey=${api}&size=9`
        + `${country ? `&country=${country}` : ""}`
        + `${category ? `&category=${category}` : ""}`
        + `${search ? `&q=${search}` : ""}`;
      setSpinner(true);
      // console.log("Final URL:", url);
      let data=await fetch(url);
      let parsedData=await data.json();
      setTotal_art(parsedData.totalResults)
      setPage(parsedData.nextPage);
      console.log(parsedData);
      let news = parsedData.results ? parsedData.results : [];
      console.log(news);
      setArticles(news);
      setSpinner(false);
    }
    fetchData();
  }, [country, category, search]);




const scrollValues = ()=>{
    setScrollTop(document.documentElement.scrollTop)
    setScrollHeight(scrollHeight);
    setInnerHeight(innerHeight);
}





  useEffect(()=> {
    window.addEventListener('scroll', scrollValues);
  },[document.documentElement.scrollTop])

  useEffect(() => {
    const f = async()=>{
    if (page!==null && scrollTop + innerHeight >= scrollHeight - 1) {
      setFetchnext_y(0);
      let url = `https://newsdata.io/api/1/latest?apikey=${api}&size=9&page=${page}`
          + `${country ? `&country=${country}` : ""}`
          + `${category ? `&category=${category}` : ""}`
          + `${search ? `&q=${search}` : ""}`;
      
      let data1=await fetch(url);
      let parsedData1=await data1.json();
      setPage(parsedData1.nextPage);
      let news = parsedData1.results ? parsedData1.results : [];
      if (news.length===0){
        // setFetchnext_y(-1);
        return;
      }
      console.log(news);
      setArticles(articles.concat(news));

      setFetchnext_y(1);
    }
  }
  if (fetchnext_y === 1){
    f();
  }
  }, [scrollTop]);





  return (
    <>
      <Navbar setMode={setMode} mode={mode} setCategory={setCategory} setCountry={setCountry} setSearch={setSearch} setSearchTemp={setSearchTemp} searchTemp={searchTemp} />
     {spinner ? <div style={{display : "flex", justifyContent: "center" , height:"100vh"}}><img style={{alignSelf: "center"}} src={`${process.env.PUBLIC_URL}/spinner.gif`} alt="" /></div> : <ALlNews articles={articles} mode={mode} country={country} category={category} search={search} />}
    {fetchnext_y===0 ?  <div data-bs-theme={mode==="light"?"light":"dark"} style={{display : "flex", justifyContent: "center" , height:"10vh"}}><img style={{color:"black",alignSelf: "center" ,height:"10vh"}} src={`${process.env.PUBLIC_URL}/spinner.gif`} alt="" /></div> : <></>}
    
    </>
  );
}

export default App;


